import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { useAppSelector } from "integrations/redux/hooks"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { selectVideoUploads } from "features/entity-caching/images/video/selectors"
import { useLiveVideoDownloadButtonData } from "plugins/Video/LiveVideo/useLiveVideoDownloadButtonData"
import { selectLiveVideoFlightById } from "features/entity-caching/flights/selectors"

export const InspectorPanelLiveVideoData = ({ id }: { id: string }) => {
    const flight = useAppSelector(selectLiveVideoFlightById(id))
    const uploads = useAppSelector(selectVideoUploads(id))
    const downloadOptions = useLiveVideoDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            <InspectorPanelMetadata
                entity={flight as SidePanelLayer}
                uploads={uploads as GenericUpload[]}
                completedUploadCount={1}
            />
        </div>
    )
}
